// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => VendorLanguage.loadInternal(), entryList => {
        VendorLanguage.θentryList.set(entryList)
        VendorLanguage.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class VendorLanguage {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "flag"] as const,
        allPropertyNames: ["id", "label", "flag"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<VendorLanguage.Id | null>;
    static readonly Id = String;
    static ids: VendorLanguage.Id[] = [] as any;
    static idsAndDisplayValues: Record<VendorLanguage.Id, string> = {} as any;
    static θentryList = signal<VendorLanguage.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<VendorLanguage.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? VendorLanguage.getEntryMap()[id]?.label : undefined
    });
    readonly θflag = computed(() => {
        const id = this.θid()
        return id !== null ? VendorLanguage.getEntryMap()[id]?.flag : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return VendorLanguage[BoInfoSymbol]
    }

    get __type(): 'Orders.VendorLanguage' {
        return 'Orders.VendorLanguage'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.VendorLanguage' {
        return 'Orders.VendorLanguage'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): VendorLanguage.Id | null {
        return this.θid()
    }

    set id(id: VendorLanguage.Id | VendorLanguage | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !VendorLanguage.getEntry(id as VendorLanguage.Id)) throw new Error('Invalid id for type Orders.VendorLanguage: ' + id)
        this.θid.set(id as VendorLanguage.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): VendorLanguage.Id[] {
        return VendorLanguage.ids
    }

    get idsAndDisplayValues(): Record<VendorLanguage.Id, string> {
        return VendorLanguage.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[VendorLanguage.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get flag() {
        return this.θflag()
    }

    get isGerman() {
        return this.id == 'de'
    }

    static get German() {
        return new this('de')
    }

    get isEnglish() {
        return this.id == 'en'
    }

    static get English() {
        return new this('en')
    }

    constructor(idOrObject: VendorLanguage.Id | VendorLanguage | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorLanguage.Entry[] {
        return This.VendorLanguage.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): VendorLanguage.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: VendorLanguage.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof VendorLanguage.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = VendorLanguage.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<VendorLanguage.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new VendorLanguage(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: VendorLanguage.Id | VendorLanguage | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as VendorLanguage.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: VendorLanguage.Id | VendorLanguage) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<VendorLanguage.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.VendorLanguage yet:', err.message)
            //throw err
        })
    }

    setGerman() {
        this.id = 'de'

    }

    setEnglish() {
        this.id = 'en'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "de", label: "German", flag: "🇩🇪" }),
            Object.freeze({ id: "en", label: "English", flag: "🇬🇧" })
        ] as VendorLanguage.Entry[]) as VendorLanguage.Entry[]
    }
}
jsonClass('Orders.VendorLanguage')(VendorLanguage)

export const VendorLanguageθId = String;

export type VendorLanguageθId = string;

export namespace VendorLanguage {
    export type Id = 'de' | 'en'

    export interface Entry {
        id: VendorLanguage.Id;
        label: string;
        flag: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => VendorLanguage.load(true))
